import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Typography } from "@mui/material";

const DeleteConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  isLoading,
  isMulti,
  count = 0,
}) => {
  return (
    <Dialog open={open} onClose={onClose} sx={{padding:"20px"}}>
      <DialogTitle>
        <Typography variant="h6" color="error">
          {isMulti ? "Delete Multiple Alerts" : "Delete Alert"}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {isMulti
            ? `Are you sure you want to delete ${count} selected alerts? This action cannot be undone.`
            : "Are you sure you want to delete this alert? This action cannot be undone."}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          color="error"
          onClick={onConfirm}
          disabled={isLoading}
        >
          {isLoading ? "Deleting..." : isMulti ? "Delete All Selected" : "Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;

